<div class="container-fluid">

    <app-pagetitle title="Stamp Orders" [actionButton]="{
            label: '+ Create Order',
            onClick: navigateStampOrderCreate
        }">
    </app-pagetitle>

    <div class="page-content-wrapper">
        <app-loader [loading]="loading"></app-loader>
        <div [class.loading-content]="loading">

            <div class="row">

                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-header">
                                <app-filter searchPlaceholder="BSR Id" [statusOptions]="statusOptions"
                                    (filterChange)="onFilterChange($event)" searchHint="BSR Id">
                                </app-filter>
                            </div>
                            <div class="card-body">
                                <p-table #dt [value]="orders" [lazy]="true" (onLazyLoad)="getStampOrders($event)"
                                    [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
                                    [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                    styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>Order Id</th>
                                            <th>Items</th>
                                            <th>Total Quantity</th>
                                            <th>Order Value</th>
                                            <th>Status</th>
                                            <th>Timestamp</th>
                                            <th>Action</th>
                                        </tr>
                                    </ng-template>

                                    <ng-template pTemplate="body" let-document>
                                        <tr>
                                            <td class="fw-bold">{{ document.bsrId }}</td>

                                            <td>
                                                {{ document.items?.length || 0 }}
                                            </td>

                                            <td>{{ getTotalQuantity(document.items) }}</td>
                                            <td>
                                                <div><span class="fw-bold text-muted">Order Amt:</span> ₹{{ document.totalValue }}
                                                </div>
                                                @if(document?.invoice?.grandTotal){
                                                <div><span class="fw-bold text-muted">Invoice Total:</span> ₹{{
                                                    document.invoice?.grandTotal }}</div>
                                                }
                                            </td>


                                            <td>
                                                <span class="badge rounded-pill px-2 py-1 small"
                                                    [ngClass]="getStatusClass(document.status)">
                                                    {{ document.status || '-' }}
                                                </span>
                                            </td>

                           

                                            <td>
                                                <div><span class="fw-bold text-muted">Created:</span> {{ document.createdAt |
                                                    date:'dd/MM/yyyy hh:mm a' }}</div>

                                                <div><span class="fw-bold text-muted">Updated:</span> {{ document.updatedAt |
                                                    date:'dd/MM/yyyy hh:mm a' }}</div>
                                            </td>


                                            <td class="text-center position-relative">
                                                <div class="action-wrapper">

                                                    <!-- Three dots -->
                                                    <button class="btn btn-sm btn-light"
                                                        (click)="toggleMenu(document._id)">
                                                        ⋮
                                                    </button>

                                                    <!-- Dropdown -->
                                                    <div class="custom-dropdown" *ngIf="activeMenuId === document._id">

                                                        <button class="dropdown-item"
                                                            (click)="getOrderDetail(document, 'view')">
                                                            <i class="mdi mdi-eye fs-4 me-2" style="cursor:pointer;"
                                                                title="View"></i>
                                                            View
                                                        </button>
                                                        @if(document?.status === 'INVOICE_GENERATED'){
                                                        <button class="dropdown-item"
                                                            (click)="getOrderDetail(document, 'payment')">
                                                            <i class="mdi mdi-credit-card fs-4 me-2"
                                                                style="cursor:pointer;" title="Payment">
                                                            </i>
                                                            Payment
                                                        </button>
                                                        }
                                                        @if(document?.status === 'ORDER_PROCESSING' || document?.status
                                                        === 'ORDER_FULFILLED' || document?.status ===
                                                        'PARTIAL_FULFILLED'){
                                                        <button class="dropdown-item"
                                                            (click)="getOrderDetail(document, 'invoice')">
                                                            <i class="mdi mdi-download fs-4 me-2"
                                                                style="cursor:pointer;" title="Download"> </i>
                                                            Invoice
                                                        </button>
                                                        }
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="8" class="text-center py-4 text-muted">
                                                <i class="mdi mdi-database-off-outline me-2"></i>
                                                No document found
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            @if(showModal){
            <div class="modal fade show d-block">
                <div class="modal-dialog">
                    <div class="modal-content">

                        <!-- Header -->
                        <div class="modal-header">
                            <div class="fw-bold">
                                <b>{{ orderDetail.bsrId }}</b>

                                <span *ngIf="orderDetail.status" class="badge rounded-pill px-2 py-1 small ms-3"
                                    [ngClass]="getStatusClass(orderDetail.status)">

                                    {{ orderDetail.status }}
                                </span>
                            </div>

                            <button class="btn-close" (click)="closeModal()"></button>
                        </div>

                        <!-- Body -->
                        <div class="modal-body">

                            <div class="row mb-3">

                                <!-- Client Name -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Client Name</div>
                                    <div>{{ orderDetail.clientName }}</div>
                                </div>

                                <!-- Client Email -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Client Email</div>
                                    <div>{{ orderDetail.clientEmail }}</div>
                                </div>

                                <!-- Total Value -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Total Value</div>
                                    <div>₹ {{ orderDetail.totalValue }}</div>
                                </div>

                                <!-- Service Charge -->
                                @if(orderDetail?.invoice?.serviceCharge){
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Service Charge</div>
                                    <div>₹ {{ orderDetail.invoice?.serviceCharge }}</div>
                                </div>
                                }

                                <!-- Grand Total -->
                                @if(orderDetail?.invoice?.grandTotal){
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Grand Total</div>
                                    <div>₹ {{ orderDetail.invoice?.grandTotal }}</div>
                                </div>
                                }

                                <!-- Total Quantity -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Total Quantity</div>
                                    <div>{{ getTotalQuantity(orderDetail.items) }}</div>
                                </div>

                                <!-- Items -->
                                <div class="col-12 mb-3">
                                    <div class="fw-semibold mb-2">Items ({{ orderDetail.items?.length || 0 }})</div>
                                    <div class="table-responsive">
                                        <table class="table table-sm table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>State</th>
                                                    <th>Denomination</th>
                                                    <th>Quantity</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of orderDetail.items; let i = index">
                                                    <td>{{ i + 1 }}</td>
                                                    <td>{{ item.stateName }}</td>
                                                    <td>₹ {{ item.denomination }}</td>
                                                    <td>{{ item.quantity }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <!-- Created Date -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Created At</div>
                                    <div>{{ orderDetail.createdAt | date:'medium' }}</div>
                                </div>

                                <!-- Updated Date -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Updated At</div>
                                    <div>{{ orderDetail.updatedAt | date:'medium' }}</div>
                                </div>

                                <!-- Excel File -->
                                <div class="col-6 mb-3" *ngIf="orderDetail?.excelUrl">
                                    <div class="fw-semibold mb-2">Uploaded File</div>
                                    <a [href]="orderDetail.excelUrl" target="_blank"
                                        class="btn btn-outline-primary btn-sm">
                                        {{ orderDetail.originalFileName || 'Download File' }}
                                    </a>
                                </div>

                                <div class="col-6 mb-3" *ngIf="orderDetail?.paymentProofUrl">
                                    <div class="fw-semibold mb-2">Payment Proof</div>
                                    <a [href]="orderDetail.paymentProofUrl" target="_blank"
                                        class="btn btn-outline-primary btn-sm">
                                        Download File
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }

            @if(showPaymentModal){
            <div class="modal fade show d-block">
                <div class="modal-dialog">
                    <div class="modal-content">

                        <!-- Header -->
                        <div class="modal-header">
                            <div class="fw-bold">
                                <b>{{ orderDetail.invoice.invoiceId }}</b>

                                <span *ngIf="orderDetail.status" class="badge rounded-pill px-2 py-1 small ms-3"
                                    [ngClass]="getStatusClass(orderDetail.status)">

                                    {{ orderDetail?.invoice?.status }}
                                </span>
                            </div>

                            <button class="btn-close" (click)="closeModal()"></button>
                        </div>

                        <!-- Body -->
                        <div class="modal-body">

                            <div class="row mb-3">

                                <!-- Client Email -->
                                <div class="col-12 mb-3">
                                    <div class="fw-semibold">Client Email</div>
                                    <div>{{ orderDetail.invoice?.clientEmail }}</div>
                                </div>

                                <!-- Stamp Value -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Stamp Value</div>
                                    <div>₹ {{ orderDetail.invoice?.stampValue }}</div>
                                </div>

                                <!-- Service Charge Rate -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Service Charge Rate</div>
                                    <div>{{ orderDetail.invoice?.serviceChargeRate * 100 }}%</div>
                                </div>

                                <!-- Service Charge -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Service Charge</div>
                                    <div>₹ {{ orderDetail.invoice?.serviceCharge }}</div>
                                </div>

                                <!-- Grand Total -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Grand Total</div>
                                    <div>₹ {{ orderDetail.invoice?.grandTotal }}</div>
                                </div>

                                <!-- Created Date -->
                                <div class="col-6 mb-3">
                                    <div class="fw-semibold">Created At</div>
                                    <div>{{ orderDetail.invoice?.createdAt | date:'medium' }}</div>
                                </div>

                            </div>

                            <div class="row">

                                <!-- Payment Mode -->
                                <div class="col-md-6 mb-3">
                                    <div class="fw-semibold mb-1">Select Payment Mode</div>

                                    <select class="form-select" [(ngModel)]="paymentMode">
                                        <option value="">Select Payment Mode</option>
                                        <option value="UPI">UPI</option>
                                        <option value="BANK_TRANSFER">Bank Transfer</option>
                                        <option value="CASH">Cash</option>
                                        <option value="CHEQUE">Cheque</option>
                                    </select>
                                </div>

                                <!-- File Upload -->
                                <div class="col-md-6 mb-3">
                                    <div class="fw-semibold mb-1">Upload Payment Proof</div>

                                    <input #fileInput type="file" class="form-control"
                                        accept=".jpg,.jpeg,.png,image/jpeg,image/png" (change)="onFileSelect($event)">

                                    <!-- Error -->
                                    <div class="text-danger mt-1" *ngIf="fileError">
                                        {{ fileError }}
                                    </div>
                                </div>

                                <!-- Upload Button -->
                                <div class="col-12 mb-3 d-flex justify-content-end">
                                    <button class="btn btn-primary" (click)="uploadFile()"
                                        [disabled]="!selectedFile || fileError || !paymentMode">
                                        <span *ngIf="upload" class="spinner-border spinner-border-sm me-2" role="status"
                                            aria-hidden="true"></span>
                                        {{upload ? 'Uploading...' : 'Upload'}}

                                    </button>
                                </div>

                                <!-- Preview -->
                                <div class="col-12 mt-2" *ngIf="previewUrl">

                                    <div class="fw-semibold mb-2">Preview</div>

                                    <div class="position-relative d-inline-block">

                                        <img [src]="previewUrl" width="150" class="border rounded">

                                        <div class="position-absolute top-0 end-0 translate-middle-y rounded-circle cross-btn"
                                            (click)="removeFile()">
                                            ✕
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }

            @if(showModal || showPaymentModal){
            <div class="modal-backdrop fade show"></div>
            }
        </div>
    </div>